import { addressSchema } from '@/components/DesignLibrary/Atoms/AddressUS/AddressUS';

const validateUSAddress = (value: unknown, required: boolean): boolean | string => {
  const areAllFieldsEmpty = (address: unknown): boolean => {
    if (!address || address === null) {
      return true;
    }

    const { city, state, zip, line1 } = address as { [key: string]: string | undefined };

    return [city, state, zip, line1].every(field => !field || field.trim() === '');
  };

  if (!required && areAllFieldsEmpty(value)) {
    return true;
  }

  const { city, state, zip, line1 } = value as { [key: string]: string | undefined };

  const isAnyFieldFilled = !!(city || state || zip || line1);

  const shouldBeRequired = required || isAnyFieldFilled;

  const schema = addressSchema(shouldBeRequired);

  const result = schema.safeParse(value);

  if (result.success) {
    return true;
  }

  return result.error.errors[0].message || 'Invalid address';
};

export default validateUSAddress;